import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import TableFixedPage from "../../TableFixedPage/TableFixedPage";
import Style from "./RestaurantProductContainer.module.scss";
import { faImages, faTrashAlt } from "@fortawesome/free-regular-svg-icons";
import Button from "../../Button/Button";
import Resizer from "react-image-file-resizer";
import Select from "react-select";
import {
  AddRestaurantProductsPostApi,
  getFoodCategoryApi,
  getSupplierListApi,
} from "../../../Api/PanelAdminServices";
import { Modal } from "react-bootstrap";
import { errorToast, succToast } from "../../../Utils/Toast/Toast";
import { useForm } from "react-hook-form";

const RestaurantProductContainer = () => {
  //////////state part /////////////
  const [foodCategory, setFoodCategory] = useState([]);
  const [suppliers, setSuppliers] = useState([]);
  const [chooseCategory, setChooseCategory] = useState();
  const [chooseSupplier, setChooseSupplier] = useState();
  const [files, setFiles] = useState([]);
  const [supId, setSupId] = useState();
  const [purchased, setPurchased] = useState(false);
  const [disable, setDisable] = useState(true);
  const [disableOk, setDisableOk] = useState(false);
  const [isBigImg, setIsBigImg] = useState(false);
  const [imgName, setImgName] = useState();
  const [packed, setPacked] = useState(false);
  /////////useEffect part /////////////
  useEffect(() => {
    getSupplier();
  }, []);

  //////validation part/////////////
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  ////////get suppliers /////////////
  const getSupplier = async () => {
    getSupplierListApi((succ,res)=>{
      if(succ){
        if(res.status===0){
          errorToast("مشکلی پیش آمده است")
        }else{
          setSuppliers(res.suppliers);
        }
      }else{
        errorToast("خطایی در سرور رخ داده است")
      }
    })
  };
  let optionsSuppliers =
    suppliers &&
    suppliers
      .filter((val) => val.type === "food")
      .map((item) => {
        return {
          value: item.id,
          label: item.name,
        };
      });
  //////////get restaurant category //////////
  const getCategory = async (id) => {
    setChooseSupplier(id);
    getFoodCategoryApi(id.value,(succ,res)=>{
      if(succ){
        if(res.status===0){
          errorToast("مشکلی پیش آمده است")
        }else{
          setFoodCategory(res.category);
          setSupId(id.value);
        }
      }else{
        errorToast("خطایی در سرور رخ داده است")
      }
    });
    setDisable(false);
  };
  let options =
    foodCategory &&
    foodCategory.map((item) => {
      return { value: item.id, label: item.category };
    });

  //////////resize upload image ///////////////
  const UploadImage = async (images) => {
    return await resizeFile(images);
  };
  const resizeFile = (file) => {
    for (let i = 0; i < file.length; i++) {
      Resizer.imageFileResizer(
        file[i],
        1024,
        1024,
        "WEBP",
        100,
        0,
        (uri) => {
          setFiles((prevfiles) => [...prevfiles, uri]);
        },
        "base64"
      );
    }
  };

  ////////////post restaurant product /////////////
  const onsubmit = (data) => {
    setDisableOk(true);
    const info = {
      category: "1",
      file: files,
      supplier_id: supId,
      other_detail: data.describe === "" ? "" : data.describe,
      price: data.price,
      name: data.name,
      category_free: chooseCategory.value,
      barcode_1: 0,
      barcode_2: 0,
      barcode_3: 0,
      off_price: 0,
      packed: packed ? 1 : -1,
      count: data.exist,
      volume: 0,
      weight: 0,
    };
    AddRestaurantProductsPostApi(info, (res) => {
      if (res.status === 0) {
        errorToast("خطایی رخ داده است");
        setDisableOk(false);
        setPurchased(false);
      } else {
        succToast("با موفقیت ثبت شد");
        setDisableOk(false);
        setPurchased(false);
      }
    });
  };
  ///////////////نمایش بزرگتر عکس
  const showBigPic = (img) => {
    setIsBigImg(true);
    setImgName(img);
  };
  ////////////حذف عکس
  const removeImage = (name) => {
    const newList = files.filter((item) => item !== name);
    setFiles(newList);
  };
  return (
    <div className={Style.componentHolder}>
      <TableFixedPage title={"ثبت کالا رستورانی"} />
      {isBigImg ? (
        <div className={Style.bigImg} onClick={() => setIsBigImg(false)}>
          <img src={`${imgName}`} alt="" />
        </div>
      ) : null}
      <form onSubmit={handleSubmit(onsubmit)} className={Style.FormAddProduct}>
        <div className={Style.imagePart}>
          {files.map((item, index) => {
            return (
              <div key={index} className={Style.eachImage}>
                <div
                  className={Style.picHolder}
                  onClick={() => showBigPic(item)}
                >
                  <img src={`${item}`} alt="" />
                </div>
                <div
                  className={Style.iconHolder}
                  onClick={() => removeImage(item)}
                >
                  <FontAwesomeIcon icon={faTrashAlt} />
                </div>
              </div>
            );
          })}
        </div>
        <div className={Style.inptFileHolder}>
          <label className={Style.lablePart} htmlFor="imgSelect">
            <FontAwesomeIcon icon={faImages} />
          </label>
          <p className={Style.placeHolderInput}>بارگذاری تصویر</p>
          <input
            className={Style.fileInputPart}
            type="file"
            id={"imgSelect"}
            onChange={(e) => UploadImage(e.target.files)}
            multiple
          />
        </div>
        <Select
          onChange={getCategory}
          className={Style.selectOptionsearch}
          placeholder={"انتخاب تامین کننده"}
          options={optionsSuppliers}
        />
        <Select
          onChange={setChooseCategory}
          className={Style.selectOptionsearch}
          placeholder={"انتخاب دسته بندی"}
          options={options}
          isDisabled={disable}
        />

        <input
          className={errors.name ? Style.errorInput : Style.fileInputPart2}
          placeholder={"عنوان محصول"}
          {...register("name", { required: true })}
          type="text"
        />
        <label className={Style.packedPart}>
          {" "}
          جزو محصولات بسته بندی شده است
          <input
            onChange={(e) => setPacked(e.target.checked)}
            className={Style.checkedPacked}
            type="checkbox"
          />
        </label>
        <select
          name=""
          id=""
          {...register("exist", { required: false })}
          // value={ProductDetailState && ProductDetailState.count}
          className={Style.fileInputPart2}
        >
          <option value="1">موجود</option>
          <option value="0">ناموجود</option>
        </select>
        <input
          className={errors.price ? Style.errorInput : Style.fileInputPart2}
          placeholder={"قیمت به تومان"}
          {...register("price", { required: true })}
          type="text"
        />
        <textarea
          placeholder={"توضیحات تکمیلی"}
          className={Style.fileInputArea}
          {...register("describe")}
        />
        <div style={{ display: "flex", justifyContent: "center" }}>
          <button
            className={Style.btnStyle}
            type={"submit"}
            disabled={disableOk}
          >
            ثبت
          </button>
        </div>
      </form>
    </div>
  );
};

export default RestaurantProductContainer;
